import { useState } from "react";
import { Plus, X } from "lucide-react";

export const DepartmentsEditor = ({ departments, onChange }) => {
    const [name, setName] = useState("");
    const [loc, setLoc] = useState("");
    const add = () => {
        if (!name.trim() || departments.some((d) => d.name.toLowerCase() === name.trim().toLowerCase())) return;
        onChange([...departments, { name: name.trim(), delivery_location: loc.trim() }]);
        setName(""); setLoc("");
    };
    return (
        <div className="mt-3 rounded-xl bg-slate-50 p-3 print:hidden" data-testid="planner-departments">
            <div className="text-[10px] font-black uppercase tracking-widest text-slate-500">Departments / delivery points</div>
            <div className="flex flex-wrap gap-1 mt-2">
                {departments.map((d, i) => (
                    <span key={d.name} className="px-2 py-0.5 rounded-full bg-white border border-slate-200 text-xs font-bold text-slate-700 inline-flex items-center gap-1" data-testid={`planner-department-${i}`}>
                        {d.name}{d.delivery_location && <span className="font-normal text-slate-400">· {d.delivery_location}</span>}
                        <button onClick={() => onChange(departments.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600"><X size={10}/></button>
                    </span>
                ))}
            </div>
            <div className="flex gap-1 mt-2">
                <input className="hdb-input !py-1 text-xs" placeholder="Department" value={name} onChange={(e) => setName(e.target.value)} data-testid="planner-department-name"/>
                <input className="hdb-input !py-1 text-xs" placeholder="Delivery point (optional)" value={loc} onChange={(e) => setLoc(e.target.value)} data-testid="planner-department-loc"/>
                <button onClick={add} className="px-2 rounded-lg bg-slate-900 text-white" data-testid="planner-department-add"><Plus size={12}/></button>
            </div>
        </div>
    );
};
